import React, { useLayoutEffect, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import SlideshowSlide from "../../../components/SlideshowSlide"
import "./index.css"
import { Autoplay, EffectFade } from "swiper";
import 'swiper/css/effect-fade';


const Slideshow = (props) => {

    const blok = props.blok

    const blocks = blok.blocks

    const [swiperPath, setSwiperPath] = useState(null)

    useLayoutEffect(() => {
        setSwiperPath(window.location.pathname)
    }, [])

    const onSlideChange = (e) => {
        const index = e.activeIndex
        const navColorScheme = blocks[index].header_color

        // fix for when a user navigates to another page, while the slideshow is playing

        if (window.location.pathname == swiperPath) {
            window.dispatchEvent(new CustomEvent('navStyleChange', { detail: {navStyle: navColorScheme, path: window.location.pathname } }))
        }
        
    }

    return (
        <section className="swiper-height relative bg-black">
            <Swiper className="w-full h-full overflow-hidden" preloadImages={true} loop={false}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                }}
                modules={[Autoplay, EffectFade]}
                effect="fade"
                speed={500}
                spaceBetween={0}
                slidesPerView={1}
                onSlideChangeTransitionStart={onSlideChange}
            >

                {blocks.map((block, index) => {
                    return (
                        <SwiperSlide key={`slideshow-slide-${index}`}>
                            <SlideshowSlide block={block} index={index}/>
                        </SwiperSlide>
                    )
                })}

            </Swiper>

        </section>
    )
}

export default Slideshow